import { render, staticRenderFns } from "./DepositHistoryWS.vue?vue&type=template&id=19afb256&scoped=true"
import script from "./DepositHistoryWS.vue?vue&type=script&lang=js"
export * from "./DepositHistoryWS.vue?vue&type=script&lang=js"
import style0 from "./DepositHistoryWS.vue?vue&type=style&index=0&id=19afb256&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19afb256",
  null
  
)

export default component.exports